import React , {Component} from 'react'
import {NavLink} from 'react-router-dom'
import './SavedImages.css'

class SavedImages extends Component{
  ab = ()=> {
    return "item/"+ "id=" + this.props.productID
 }
render(){
    return (   
    <li className="saved-item">
    <NavLink className="url" to={this.ab()}>
   <div className="saved-image">
   <img className="Savedimage" src={this.props.image}></img>
   </div>
 </NavLink>
 </li>)
}
}
export default SavedImages